<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.unidades"
        ref="DataTable"
        sort-by="nomeFantasia"
    >

        <template v-slot:cell(actions)="{ item }">

            <rkm-button
                @click.stop="$router.push({ name: 'exame-laboratorial-jornada-create', params: { id: item.id } })"
                color="primary"
                title="Visualizar"
                small
            >
                <rkm-icon icon="search" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories.unidades = this.getConectaSusRepository('exameLaboratorial.jornada')
    },
    data: () => ({
        fields: [
            {
                key: 'nomeFantasia',
                name: 'nomeFantasia',
                label: 'Unidade - Local de atendimento',
                searchable: true,
                sortable: true,
            },
            {
                class: 'col-min',
                key: 'actions',
                label: 'Ações',
                name: 'actions',
            },
        ],
        repositories: {
            unidades: null,
        },
    }),
    mixins: [ repository, error ],
}
</script>